export default __webpack_public_path__ + "static/Singapore Airshow-cd18a955d1624134ab4ff43cb42190da.png";